import $ from "jquery";

class Modal {
    run() {
        this.videoPopup();
        this.toggleContact();
        this.quotationFlexlabeller();
        this.quotationEasyCapper();
    }

    videoPopup() {
        $('.kit-available .item button, .video-toggler').on('click',function() {
            var dataPoster = $(this).data('poster');
            var dataVideo = $(this).data('video');

            var video = '<video id="videoComplete" autoplay muted controls poster="'+dataPoster+'" preload="none" class=""><source src="'+dataVideo+'" type="video/mp4"></video>';

            $('#videopopup video').remove();
            $('#videopopup').append(video);
            $('#videopopup').addClass('active');
            $('#videopopup video').attr('poster', dataPoster);
            $('#videopopup video source').attr('src', dataVideo);
        });

        $('#videoClose').on('click',function() {
            $('#videopopup').removeClass('active');
            $('#videoComplete').get(0).pause();
            $('#videoComplete').get(0).currentTime = 0;
            $('#videopopup video').remove();
        });
    }

    toggleContact() {
        let root = document.documentElement;
        const header = $('header');
        const contactForm = $('#contact-form');
        const contactToggler = $('#contact-toggler, .contact-toggler');
        const contactCloser = $('#contact-closer');

        if(contactForm.length > 0){

            contactToggler.on('click', function(e){
                contactForm.toggleClass('active');
                header.toggleClass('form-active');
                $('body').toggleClass('overflow-hidden');
            });

            contactCloser.on('click', function(e){
                contactForm.toggleClass('active');
                header.toggleClass('form-active');
                $('body').toggleClass('overflow-hidden');
            });
        };
    }

    quotationFlexlabeller() {
        $('.contact-toggler').on('click',function(e){
            var product = $(this).data('product');
            var line = $(this).data('line');
            $('.wpcf7-form-control[name="product_name"]').val(product);
            $('.wpcf7-form-control[name="product_line"]').val(line);
        });

        $('input[type="radio"][name="color"]').on('click',function(e){
            var kind = e.target.value;
            $('.wpcf7-form-control[name="color"]').val(kind);
        });

        $('input[type="checkbox"][name="kit"]').on('click',function(e){
            var kits = [];

            $('input[type="checkbox"][name="kit"]').each(function(){
                if($(this).prop('checked'))
                kits.push($(this).val());
            });
            $('.wpcf7-form-control[name="kits"]').val(kits.join(", "));
        });
    }

    quotationEasyCapper() {
        $('input[type="radio"]').on('click',function(e){
            $('input[type="radio"]').removeClass('selected');
            $(this).addClass('selected');

            var kind = e.target.value;
            $('.wpcf7-form-control[name="kind"]').val(kind);

            if($('input[value="oil"]').hasClass('selected')){
                $('input[name="cap"]').prop('disabled', false);
            } else {
                $('input[name="cap"]').prop('disabled', true);
                $('input[name="cap"]').prop('checked', false);
            }
        });

        $('input[value="wine"]').on('click',function(e){
            $('.wpcf7-form-control[name="kit"]').val('');
        });

        $('input[name="cap"]').on('click',function(e){
            var kind = e.target.value;
            $('.wpcf7-form-control[name="kit"]').val(kind);
        });
    }
}

const modal = new Modal();
export default modal;
